import { render, staticRenderFns } from "./NewUserInfo.vue?vue&type=template&id=7c176032&scoped=true&"
import script from "./NewUserInfo.vue?vue&type=script&lang=js&"
export * from "./NewUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewUserInfo.vue?vue&type=style&index=0&id=7c176032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c176032",
  null
  
)

export default component.exports